import {projectKey} from '../config'
/**
 * Created by Administrator on 2017/3/27.
 */
class Session {
  constructor () {
    this.__init()
  }

  __init () {
    console.log('window.localStorage====', window.localStorage)
  }

  markKey (key) {
    return projectKey + key
  }

  put (key, value) {
    key = this.markKey(key);
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  get (key) {
    key = this.markKey(key);
    return JSON.parse(window.localStorage.getItem(key))
  }

  delete (key) {
    key = this.markKey(key);
    window.localStorage.removeItem(key);
  }

  login (accountToken) {
    var isLogin = this.get('isLogin');
    if (!isLogin) {
      this.put('accountToken', accountToken);
      this.put('isLogin', true)
    }else {
      this.put('accountToken', accountToken);
    }
  }

  logout () {
    this.put('isLogin', false);
    this.delete('accountToken')
  }

  userInfo(userInfo){
    this.put('userInfo', userInfo);
  }

  getUserInfo () {
    return this.get('userInfo') || {}
  }

  isLogin () {
    return !!this.get('isLogin') || false
  }
  getAccountToken(){
    return this.get('accountToken')
  }
  getBaseImageUrl () {
    return "http://img.shuimujiaju.com/";
  }

}
export default new Session()
